const readMore = () => {
  function slidetoggle() {
    this.parentNode.removeChild(this);
    document
      .querySelectorAll(this.getAttribute('data-slidetoggle'))
      .forEach((el) => {
        const ch = el.clientHeight,
          sh = el.scrollHeight,
          isCollapsed = !ch,
          noHeightSet = !el.style.height;

        el.style.height = (isCollapsed || noHeightSet ? sh : 0) + 'px';
        if (noHeightSet) return slidetoggle.call(this);
      });
  }

  document
    .querySelectorAll('[data-slidetoggle]')
    .forEach((el) => el.addEventListener('click', slidetoggle));
};

export default readMore;
